import { Component, OnInit ,Input} from '@angular/core';

@Component({
  selector: 'app-image-gallery',
  templateUrl: './image-gallery.page.html',
  styleUrls: ['./image-gallery.page.scss'],
})
export class ImageGalleryPage implements OnInit {
  @Input() product_id;
  @Input() product_info;
  @Input() current_img;
  @Input() current_img_id;
  index;
  constructor() { }

  ngOnInit() {
    // console.log(this.product_info)
    // console.log(this.current_img)
    // console.log(this.current_img_id)
    setTimeout(() => {
    const val:any = document.getElementById('1d');
    console.log(val)
    val.click();

    // const val1 = document.getElementById('1s');
    // // const val2 = document.getElementById('1s');
    // console.log(val1)
    // val1.click();
      
    }, 1500);

    // if(this.current_img_id != undefined){
    //   for(let i=0;i< this.product_info.product_images.length;i++){
    //     if(this.current_img_id == this.product_info.product_images[i]){
    //       let doc = document.getElementsByTagName('fiv-gallery-image');
    //     }
    //   }
    // }
  }

  get_img(event){
    console.log('event')
  }
  

  

}
